export const WorkOrdersPermissions = {
  ViewAndSearchInPropertyManagementWorkOrders: {
    components: null,
    componentsId: null,
    permissionsId: 'd2e1c5a8-4e9c-467c-c9ce-08d94f66fc61',
    permissionsName: 'View and search in  Property Management WorkOrders'
  },
  ViewAndSearchWorkOrders: {
    components: null,
    componentsId: null,
    permissionsId: '2ec8082c-77c6-460e-931f-08d967db92be',
    permissionsName: 'View and search Work Orders'
  },
  CreateOrUpdateWorkOrder: {
    components: null,
    componentsId: null,
    permissionsId: 'e9c7f32c-2d01-426f-9320-08d967db92be',
    permissionsName: 'Create Or Update Work Order'
  },
  EditWorkOrder: {
    components: null,
    componentsId: null,
    permissionsId: 'a1bf7a09-78e9-4178-9321-08d967db92be',
    permissionsName: 'Edit Work Order'
  },
  DeleteWorkOrder: {
    components: null,
    componentsId: null,
    permissionsId: 'e04dc628-8d5f-4ea7-9322-08d967db92be',
    permissionsName: 'Delete Work Order'
  },

  ViewContacts: {
    components: null,
    componentsId: null,
    permissionsId: '4368acd4-4cbf-4b0c-9323-08d967db92be',
    permissionsName: 'view contacts'

  }


};
